// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___fCmd","clinicsSelect":"styles_clinicsSelect__1N7eJ"};